import React from 'react';

import { NavLink } from 'react-router-dom';

import { withStyles, createStyleSheet } from 'material-ui/styles';
import { Item, FAB, Container, LoadMoreButton } from 'components';
import ModeEditIcon from 'material-ui-icons/ModeEdit';

import StackCard from './StackCard';

const styleSheet = createStyleSheet('StackList', theme => {
  return {
    loadMoreButtonWrapper: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    loadMoreButton: {
      [theme.breakpoints.only('xs')]: {
        width: '100% !important',
      },
      [theme.breakpoints.up('sm')]: {
        width: 'initial !important',
      },
    },
  };
});

const StackList = ({ data, onLoadMore, hasMore, classes }) => {
  return (
    <Container container>
      <FAB component={NavLink} to="/stack/add">
        <ModeEditIcon />
      </FAB>
      {data.allStacks &&
        data.allStacks.map(stack =>
          <Item>
            <StackCard {...stack} />
          </Item>
        )}

      <div className={classes.loadMoreButtonWrapper}>
        <LoadMoreButton
          hasMore={hasMore}
          loading={data.loading}
          onClick={onLoadMore}
          className={classes.loadMoreButton}
        />
      </div>
    </Container>
  );
};

export default withStyles(styleSheet)(StackList);



// WEBPACK FOOTER //
// ./src/App/Stack/components/StackList.js